import axios from "../api/axios";
import useAuth from "./useAuth";

const useRefreshToken = () => {
  const { setAuth } = useAuth();

  const refresh = async () => {
    const response = await axios.get("/refresh", {
      withCredentials: true,
    });
    setAuth((prev) => {
      return {
        ...prev,
        roles: response.data.roles,
        accessToken: response.data.accessToken,
        allowedColumns: response.data.allowedColumns,
        allowedAddData: response.data.allowedAddData ?? "",
        allowedDeleteData: response.data.allowedDeleteData ?? "",
      };
    });
    return response.data;
  };
  return refresh;
};

export default useRefreshToken;
